<div class="radios-list options">
    @for (option of options; track option; let i = $index) {
        <div class="control radio-tile is-horizontal">
            <a [attr.href]="urls && urls[i] ? urls[i] : null" (click)="haltDisabledEvents($event)">
                <input
                    type="radio"
                    id="item{{ i }}-{{ UID }}"
                    class="items-{{ UID }}"
                    name="options_group-{{ UID }}"
                    (click)="selectOption(option, $event)"
                    value="{{ option }}"
                    [attr.disabled]="availableValues && !availableValues.includes(option) ? '' : null"
                />
                <label class="radio-label small-radio-label" for="item{{ i }}-{{ UID }}">
                    <span class="radio-title has-text-tertiary">{{ option }}</span>
                </label>
            </a>
        </div>
    }
</div>
